import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class CategoryAnalyticssplinechart extends Component {
    constructor(props) {
        super(props);
        this.state = {

            series: [{
                name: 'Waiting',
                data: [123, 100, 132, 94, 114, 120]
            }, {
                name: 'Service',
                data: [72, 56, 54, 74, 91, 27]
            }],
            options: {
                chart: {
                    height: 285,
                    type: 'area',
                    toolbar: {
                        show: false
                    }
                },
                grid: {
                    show: false
                },
                dataLabels: {
                    enabled: false
                },
                colors: ['#17C2D7', '#9367B4', '#9367B4'],
                markers: {
                    size: 3,
                    strokeColor: ['#17C2D7', '#9367B4', '#9367B4'],
                  },
                stroke: {
                    width: 2,
                    curve: 'smooth',
                },
                xaxis: {
                    type: 'category',
                    axisTicks: { show: false },
                    axisBorder: { show: false },
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
                },
                yaxis: {
                    tickAmount: 8,
                    min: 0,
                    max: 200
                },
                legend: {
                    show: true
                }
                // tooltip: {
                //     x: {
                //         format: 'dd/MM/yy HH:mm'
                //     },
                // },
            },
        };
    }
    render() {
        return (
            <div>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="area"
                    height="285px"
                />
            </div>
        );
    }
}

export default CategoryAnalyticssplinechart;
